import { Outlet } from "react-router-dom";
import { AgentSidebar } from "./AgentSidebar";
import { Menu } from "lucide-react";
import { useUIStore } from "@/store/ui-store";

export function AgentLayout() {
  const { toggleMobileMenu } = useUIStore();

  return (
    <div className="min-h-screen flex bg-surface-50">
      <AgentSidebar />
      <div className="flex-1 flex flex-col min-w-0">
        
        {/* 📱 Mobile Topbar with Menu Button */}
        <header className="lg:hidden h-14 bg-white border-b border-surface-200 flex items-center px-4 sticky top-0 z-30 shadow-sm">
          <button 
            onClick={toggleMobileMenu} // 🛠️ FIXED function name here
            className="p-2 -ml-2 text-surface-600 hover:bg-surface-100 rounded-md"
          >
            <Menu className="h-6 w-6" />
          </button>
          <div className="ml-2 font-bold text-surface-900">Agent Portal</div>
        </header>

        <main className="flex-1 p-4 lg:p-8">
          <div className="max-w-5xl mx-auto animate-fade-in">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}